import {
  login
} from '@/apiconfig';
import ajaxUtil from '@/utils/ajaxUtil';
import types from '@/store/types';

const getUserBriefAsync = ({
  state,
  commit
}) => new Promise((resolve) => {
  ajaxUtil.post({
    url: login.getUserBriefInfo,
    token: state.token
  }).then((result) => {
    commit(types.UPDATE_USER_BRIEF, result.data);
    resolve(result);
  });
});

/**
 *检测用户状态
 * @param payload 如果是pc过来就穿token给后台返回新的token，如果是供应商就穿providerId
 * @param sourceType 0--pc采购，1--供应商后台
 */
const checkUserStatus = ({
  commit
}, {
  payload,
  sourceType
}) => new Promise((resolve, reject) => {
  ajaxUtil.post({
    url: login.checkCompanyStatus,
    params: {
      payload,
      sourceType,
      token: ''
    }
  }).then((result) => {
    const { token, providerId, companyStatus } = result.data;
    if (providerId === -1 && sourceType === 1) { // 供应商查不到id
      reject(result);
      return;
    }
    if (providerId !== -1) {
      commit(types.UPDATE_PROVIDERID, providerId); // 接受解密后的providerId
    }

    commit(types.UPDATE_USER_BRIEF, {
      companyType: sourceType,
    });
    commit(types.UPDATE_COMPANY_STATUS, companyStatus);
    if (token) {
      commit(types.UPDATE_TOKEN, token);
    }
    resolve(result);
  });
});

/**
 *  检测供应商端用户初始配置状态
 *  @param token 登陆返回的token值
 * */
const getInitialSet = ({
  state,
  commit
}) => new Promise((resolve, reject) => {
  ajaxUtil.post({
    url: login.loginReminderForInitialSet,
    params: {
      token: state.token
    }
  }).then((result) => {
    if (result.code !== '40001') {
      reject(result);
      return;
    }
    commit(types.UPDATE_COMPLETE_INIT, result.data.needInitialSet);
    resolve(result);
  });
});

export default {
  getUserBriefAsync,
  checkUserStatus,
  getInitialSet,
};
